import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        currentLanguage: {
            name: "EN",
            value: "en",
        },
    },
    mutations: {},
    actions: {},
    getters: {
        getLanguages(state) {
            return state.languages;
        },
        getCurrentLanguage(state) {
            return state.currentLanguage;
        },
    },
    modules: {}
})